export async function uploadToR2(
  file,
  msgIdOrOptions = null,
  type = "message",
  onProgress = () => {}
) {
  /* =========================================
     SUPPORT BOTH OLD + NEW API
  ========================================= */

  let options;

  if (
    msgIdOrOptions &&
    typeof msgIdOrOptions === "object" &&
    !Array.isArray(msgIdOrOptions)
  ) {
    options = {
      msgId: null,
      statusId: null,
      type: "message",
      onProgress: () => {},
      ...msgIdOrOptions,
    };
  } else {
    options = {
      msgId: msgIdOrOptions,
      statusId: null,
      type,
      onProgress,
    };
  }

  const {
    msgId,
    statusId,
    type: uploadType,
  } = options;

  const progress =
    typeof options.onProgress === "function"
      ? options.onProgress
      : () => {};

  const API_BASE =
    "https://metisel.com/api/upload-r2";

  /* =========================================
     STEP 1 — REQUEST PRE-SIGNED URL
  ========================================= */

  const initRes = await fetch(
    `${API_BASE}/init`,
    {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        type: uploadType,
        msgId,
        statusId,
        fileName: file.name,
        contentType: file.type,
      }),
    }
  );

  const initData = await initRes.json();

  if (!initRes.ok) {
    throw new Error(
      initData.error ||
      "Failed to initialize upload"
    );
  }

  const {
    uploadUrl,
    objectKey,
    url,
    encrypted,
  } = initData;

  /* =========================================
     STEP 2 — DIRECT UPLOAD TO R2
  ========================================= */

  await new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();

    xhr.open("PUT", uploadUrl);

    xhr.setRequestHeader(
      "Content-Type",
      uploadType === "message" ||
      uploadType === "group-message"
        ? "application/octet-stream"
        : file.type || "application/octet-stream"
    );

    xhr.upload.onprogress = (event) => {
      if (event.lengthComputable) {
        progress(
          Math.round(
            (event.loaded / event.total) * 100
          )
        );
      }
    };

    xhr.onload = () => {
      if (
        xhr.status >= 200 &&
        xhr.status < 300
      ) {
        resolve();
      } else {
        reject(
          new Error(
            "Failed to upload file to R2"
          )
        );
      }
    };

    xhr.onerror = () =>
      reject(
        new Error(
          "Network upload error"
        )
      );

    xhr.send(file);
  });

  /* =========================================
     STEP 3 — FINALIZE UPLOAD
  ========================================= */

  const completeRes = await fetch(
    `${API_BASE}/complete`,
    {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        type: uploadType,
        msgId,
        statusId,
        objectKey,
      }),
    }
  );

  const completeData =
    await completeRes.json();

  if (!completeRes.ok) {
    throw new Error(
      completeData.error ||
      "Failed to finalize upload"
    );
  }

  return {
    success: true,
    url,
    objectKey,
    encrypted,
  };
}